import { createContext, useContext } from "react";

const InterventionContext = createContext();

export const useContextIntervention = () => {
  return useContext(InterventionContext);
};

export const useContextInterventionAsset = () => {
  const intervention = useContextIntervention();
  const asset = intervention?.asset ?? {};

  return asset;
};

export default InterventionContext;
